export default "__VITE_ASSET__B_55tw_K__"